import { AfterContentChecked } from '@angular/core';
import { AfterViewChecked, AfterViewInit, Component, OnInit, Pipe, PipeTransform , ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from "lodash";
import { element } from 'protractor';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import { SharedService } from 'src/app/Service/shared.service';
declare var $: any

@Component({
  selector: 'app-appel-manifestation',
  templateUrl: './appel-manifestation.component.html',
  styleUrls: ['./appel-manifestation.component.scss']
})
export class AppelManifestationComponent implements OnInit {
  

  constructor(private global: Global, private service: PublicationsService, private shared: SharedService, private route: ActivatedRoute,private router: Router,private translate: TranslateService) { }


  // Download form fields
  fullName: string = '';
  email: string = '';
  companyName: string = '';
  companyPhone: string = '';
  secteur: string ='';
  terms: boolean = false;
  error: string = '';
  download : boolean=false;
  
//file id
Id=1;
  ngOnInit(): void {
  }

  onSubmit(form: any) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(this.email)) {
      this.error = 'Veuillez entrer une adresse email valide.';
      return;
    }
  
    const phoneRegex = /^(\+\d{1,2}\s?)?1?\-?\s?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{4}$/;
    if (!phoneRegex.test(this.companyPhone)) {
      this.error = 'Veuillez entrer un numéro de téléphone valide.';
      return;
    }
  
    if (!this.fullName || !this.email || !this.companyName || !this.companyPhone || !this.terms || !this.secteur ){
      this.error = 'Veuillez remplir tous les champs correctement.';
      return;
    }
  
    if (form.valid) {
      // Prepare the data to send to SharePoint
      const postData = {
        "__metadata": {
          "type": "SP.Data.AMIListItem"
        },
        Title: this.fullName,
        Email: this.email,
        Raison_x0020_sociale: this.companyName,
        Telephone: this.companyPhone,
        Secteur_x0020_activite:this.secteur
      };
  
      // Fetch the X-RequestDigest token before making the POST request
      this.service.getRequestDigest().subscribe(
        (response: any) => {
          const requestDigest = response.FormDigestValue;
  
          // Now make the POST request to add the item
          this.service.AddAmi(postData, requestDigest).subscribe(
            (response) => {
              // After adding the item, download the dossier
              this.download = true;
              window.open("https://www.anp.org.ma/fra/Documents%20partages/ANP_AMI_01_2025.pdf");
              
            },
            (error) => {
              console.error('Error posting data:', error);
              // Handle errors (e.g., show error message)
            }
          );
        },
        (error) => {
          console.error('Error fetching X-RequestDigest:', error);
          // Handle errors in retrieving the digest
        }
      );
    } else {
      this.error = 'Veuillez remplir tous les champs correctement.';
    }
  }
}
